document.querySelectorAll("[data-sortby-item]").forEach((item) => {
  item.addEventListener("click", function () {
    // Remove 'is--selected' class from any currently selected item
    document
      .querySelectorAll("[data-sortby-item].is--selected")
      .forEach((selectedItem) => {
        selectedItem.classList.remove("is--selected");
      });

    console.log("CLICKED::");

    closeSortingModal();

    // Add 'is--selected' class to the clicked item
    this.classList.add("is--selected");
  });
});

window.addEventListener("popstate", () => {
  console.log("popstatexxxx");
  const currentUrl = window.location.href;
  const queryParams = new URLSearchParams(window.location.search);
  console.log("URL changed:", currentUrl);
  if (queryParams.has("action")) {
    console.log("Action parameter:", queryParams.get("action"));
  }
});
